import { AxiosResponse } from 'axios'
import { cdcServiceAPI, generalServiceV1API } from '@/store/api-instance'
import { ISetUserVerificationRequest } from '@/store/modules/auth/interfaces/setUserVerification/ISetUserVerificationRequest'
import { ISetUserVerificationPhoneRequest } from '@/store/modules/auth/interfaces/setUserVerification/ISetUserVerificationPhoneRequest'
import { ISetFirstLogin } from '@/store/modules/auth/interfaces/setFirstLogin/ISetFirstLogin'

async function setUserVerificationAPI (params: ISetUserVerificationRequest) {
  const response: AxiosResponse = await cdcServiceAPI.put<boolean>('users/SetFirstPassword', params)
  return response.data
}

async function setUserVerificationPhoneAPI (params: ISetUserVerificationPhoneRequest) {
  const response: AxiosResponse = await cdcServiceAPI.put<boolean>('users/SetFirstUserInfoSMS', params)
  return response.data
}
async function setUserReValidateAPI (params: ISetUserVerificationPhoneRequest) {
  const response: AxiosResponse = await cdcServiceAPI.put<boolean>('users/RevalidateUser', params)
  return response.data
}

async function setFirstLogin (params: ISetFirstLogin) {
  const response: AxiosResponse = await cdcServiceAPI.request<boolean>({
    method: 'PUT',
    url: `users/SetFirstLoginFlag/${params.UID}`,
    headers: {
      'content-type': 'application/json'
    },
    data: params.firstLogin
  })
  return response.data
}

async function getUserInformationAPI (UID: string) {
  const response: AxiosResponse = await cdcServiceAPI.get(`users/GetUserInfoById/${UID}`)
  return response.data
}

async function getDefaultShipToAPI () {
  const response: AxiosResponse = await generalServiceV1API.get('payers/defaultshipto')
  return response.data
}

export { setUserVerificationAPI, getUserInformationAPI, setFirstLogin, setUserVerificationPhoneAPI, getDefaultShipToAPI, setUserReValidateAPI }
